var _rect, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEgg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2048,
    height: 2048,
    viewBox: "0 0 2048 2048",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2048,
    height: 2048,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 150,
    width: 1748,
    height: 1748,
    fill: "url(#pattern0_52_2)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_52_2",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_52_2",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_52_2",
    width: 48,
    height: 48,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAASmSURBVHgB7VpdaBxVFD73zuxuN9n8bJLd/G2yyepm4yYmpNm0ppX4k1YMxdKfNC++tEqlKkSqVqyiNI/iD1VCFRGhqA+GUEse9FUQBJ+kor4EG0ssLQnmZ5L9mZ2Zez13A7Wl+dnZnel2IR8sDHPnnnO+c+8599y7l0wMd2k6cF7ulIlhcCgGSJTAiqZziQDIBufwx9zqn9OL8csuKnuhCKAyttDmdR/uqPVE5TKnDNOLye8mfp8bgyLCSNRPHglUdlAxAi6JVEGRwSFLXmE7hSLHNoFCY5vAJiAbPFsKWwm8UF9fcizq89ipxy7BQi6L9VZNPtnq+wafDbBJl10E+Knutka/Rx6qK3McPNMXrRPvwAbYQUDCH98XcU3NKipcX1b57lZpCtYIWK7PDgLG2T3BfhS9kwA3OAEGhPaN9gf3YBsDi2E1AeF9GIr4Ls0qSTSWiIJRml1K8uF239Tt31gFKwkIWcbHg6FX/lpI1jno/6JlmXJ8V31+8IFRWAtoy9KqpSNwvAV2xGrKzytpnd0um2DNtYzv+mrKPni9q7YULNRrlaBM2nw8Fr3466oKEiF3eVjGd9jm6Az7vgQL06pVBPiJQX+olLlGGGfC++tNEYJNhoc7Rl4aqGoCi9KqFQQyafNIbf3UjWQKBZIN5zcOgnQjkeRPNzd9D2sE8g7ofAkIY40zA61Praq8gxK2ZYASylk8xTpf29u8HywIaCsIwGBT9cR8Qs2kzSy6SPNxjQ+2+CatsCGfzsJ49slQ27uzK/EKasKTeKjAr68kyj/cH3kH8hyFvAjsjdSUhbwlYymdMyDEjBE0pTMj4nefO4gyoAAExFRhb/QGvp1ZSok8b9oADHb692KKHkcZsFZi5GRLrgTYW7GmTlyuhkS9g+abJsAz6xv2RRlnuxvbIMe0mgsBWSgbDnovXVtO8ewCd30gb2kGZYyEq36AHNOqWQLC0/rYvvDRK8DCTlyaIE840fArHELnnggfgRwCOhcC8LC39CslobF8vH9LIAGqJNKsu6b0Ym8vOMzaZObjTL3zxdH2j+aTqlsCktcCdIdgzKtzibTn5eb298DkKJhiO/Rgna/B5T6tGljvELCMAM5+ige2rM5dcvpQS2Wlma7ZEsikzRM7GyavLiVxIbLO+7cMQYdcXYrDs7tCl8HE9jNbAsab/cEe4NoAiNRnzzkPplWcPjz92Kuxhh7IcvuZDYFMoO4KVk7djFsTuBtBpNWbqzp/NJT99nMrAplq87NnHnpeSekBAvfgHxxUomhGYPxA5DnIIqCzIQCNFe4LYpuIHrL9LBUVUkXVWbCi5MKxaNQJeRDIpM2fDrR/Pq2oTsqJHfN+fcWoaTqedo0G2ThsUSfJm8jhp2LBnhWf52T5v3HgjntHAEF3YKZW/J6TL+4OjH/6yz+/bfThpgSaPLTj55nF9zmwJSgArinpioDb0YWPORFwvP3jzNdwf0CUGNp6DZvFgAb3Dza0ZfsfmkJjm0ChQcXFCVXjC1Bk0BhfwDNYkFfSOg9Xuw+PdPrBQYvjyoGm84VwlfuQuLFCxHUbhjWaxyWBuHtQDJBw5meu22Cd9B8d9o58eJxB8AAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEgg);
export default __webpack_public_path__ + "static/media/Egg.e9c79be832ccea8e224e65aa5d7af297.svg";
export { ForwardRef as ReactComponent };